import { render, staticRenderFns } from "./AppLayoutAdmin.vue?vue&type=template&id=bc3625c6&"
import script from "./AppLayoutAdmin.vue?vue&type=script&lang=js&"
export * from "./AppLayoutAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports